/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type HasDismissedRecommendedPrintItemsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type HasDismissedRecommendedPrintItemsQuery = {
    __typename: 'Query';
    me: { __typename: 'Viewer'; id: string; hasDismissedRecommendedPrintItems: boolean };
};

export type SetDismissedRecommendedPrintItemsMutationVariables = Types.Exact<{
    [key: string]: never;
}>;

export type SetDismissedRecommendedPrintItemsMutation = {
    __typename: 'Mutation';
    setCompletedAction: {
        __typename: 'Viewer';
        id: string;
        hasDismissedRecommendedPrintItems: boolean;
    };
};

export const HasDismissedRecommendedPrintItemsDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'HasDismissedRecommendedPrintItems' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'me' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                {
                                    kind: 'Field',
                                    alias: {
                                        kind: 'Name',
                                        value: 'hasDismissedRecommendedPrintItems',
                                    },
                                    name: { kind: 'Name', value: 'hasDone' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'action' },
                                            value: {
                                                kind: 'StringValue',
                                                value: 'your-work/dismiss-recommended-print-products',
                                                block: false,
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};

/**
 * __useHasDismissedRecommendedPrintItemsQuery__
 *
 * To run a query within a React component, call `useHasDismissedRecommendedPrintItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasDismissedRecommendedPrintItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasDismissedRecommendedPrintItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasDismissedRecommendedPrintItemsQuery(
    baseOptions?: Apollo.QueryHookOptions<
        HasDismissedRecommendedPrintItemsQuery,
        HasDismissedRecommendedPrintItemsQueryVariables
    >
) {
    return Apollo.useQuery<
        HasDismissedRecommendedPrintItemsQuery,
        HasDismissedRecommendedPrintItemsQueryVariables
    >(HasDismissedRecommendedPrintItemsDocument, baseOptions);
}
export function useHasDismissedRecommendedPrintItemsLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        HasDismissedRecommendedPrintItemsQuery,
        HasDismissedRecommendedPrintItemsQueryVariables
    >
) {
    return Apollo.useLazyQuery<
        HasDismissedRecommendedPrintItemsQuery,
        HasDismissedRecommendedPrintItemsQueryVariables
    >(HasDismissedRecommendedPrintItemsDocument, baseOptions);
}
export type HasDismissedRecommendedPrintItemsQueryHookResult = ReturnType<
    typeof useHasDismissedRecommendedPrintItemsQuery
>;
export type HasDismissedRecommendedPrintItemsLazyQueryHookResult = ReturnType<
    typeof useHasDismissedRecommendedPrintItemsLazyQuery
>;
export type HasDismissedRecommendedPrintItemsQueryResult = Apollo.QueryResult<
    HasDismissedRecommendedPrintItemsQuery,
    HasDismissedRecommendedPrintItemsQueryVariables
>;
export const SetDismissedRecommendedPrintItemsDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'mutation',
            name: { kind: 'Name', value: 'SetDismissedRecommendedPrintItems' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'setCompletedAction' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'action' },
                                value: {
                                    kind: 'StringValue',
                                    value: 'your-work/dismiss-recommended-print-products',
                                    block: false,
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                {
                                    kind: 'Field',
                                    alias: {
                                        kind: 'Name',
                                        value: 'hasDismissedRecommendedPrintItems',
                                    },
                                    name: { kind: 'Name', value: 'hasDone' },
                                    arguments: [
                                        {
                                            kind: 'Argument',
                                            name: { kind: 'Name', value: 'action' },
                                            value: {
                                                kind: 'StringValue',
                                                value: 'your-work/dismiss-recommended-print-products',
                                                block: false,
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};
export type SetDismissedRecommendedPrintItemsMutationFn = Apollo.MutationFunction<
    SetDismissedRecommendedPrintItemsMutation,
    SetDismissedRecommendedPrintItemsMutationVariables
>;

/**
 * __useSetDismissedRecommendedPrintItemsMutation__
 *
 * To run a mutation, you first call `useSetDismissedRecommendedPrintItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDismissedRecommendedPrintItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDismissedRecommendedPrintItemsMutation, { data, loading, error }] = useSetDismissedRecommendedPrintItemsMutation({
 *   variables: {
 *   },
 * });
 */
export function useSetDismissedRecommendedPrintItemsMutation(
    baseOptions?: Apollo.MutationHookOptions<
        SetDismissedRecommendedPrintItemsMutation,
        SetDismissedRecommendedPrintItemsMutationVariables
    >
) {
    return Apollo.useMutation<
        SetDismissedRecommendedPrintItemsMutation,
        SetDismissedRecommendedPrintItemsMutationVariables
    >(SetDismissedRecommendedPrintItemsDocument, baseOptions);
}
export type SetDismissedRecommendedPrintItemsMutationHookResult = ReturnType<
    typeof useSetDismissedRecommendedPrintItemsMutation
>;
export type SetDismissedRecommendedPrintItemsMutationResult =
    Apollo.MutationResult<SetDismissedRecommendedPrintItemsMutation>;
export type SetDismissedRecommendedPrintItemsMutationOptions = Apollo.BaseMutationOptions<
    SetDismissedRecommendedPrintItemsMutation,
    SetDismissedRecommendedPrintItemsMutationVariables
>;
